/* eslint-disable no-restricted-imports */
import React, {useMemo, useRef} from 'react'
import {UIGameActionButton} from '../../../common/UIGameActionButton/index.ts'
import {
    UIGameResourceCardsTooltipContent,
    type UIGameResourceCardsTooltipContentHandle,
} from '../../../common/UIGameResourceCardsTooltipContent/index.ts'
import {getCardsForPiece} from '@colonist/game-card-types'
import {GameAction, PieceTypes} from '@colonist/game-base-types'
import {ACTION_BUTTON_IDS, useActionButtonCommonErrors} from '../utils.ts'
import {type TranslationObject} from '@colonist/i18n'
import CardDevCardBack from '@static/images/card_devcardback.svg'
import {useGameStore} from '../../../store/GameStoreContext.ts'
import {usePlayerValidators} from '../../../store/selectors/usePlayerValidators.ts'
import {useUIGameSocketContext} from '../../../contexts/UIGameSocketContext.tsx'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import clsx from 'clsx'
import styles from '../UIGameActionButtonContainer.module.scss'
import {useMechanicValidatorDevelopmentCard} from '../../../store/selectors/useMechanicValidatorDevelopmentCard.ts'

const cardsToBuyDevCard = getCardsForPiece(PieceTypes.DevelopmentCard)

export const UIGameActionButtonBuyDevelopmentCard = ({
    className,
    hideTooltip,
}: {
    className?: string
    hideTooltip?: boolean
}) => {
    const myColor = useGameStore((state) => state.myColor)
    const {errorHelperText, hasCommonErrors} = useActionButtonCommonErrors()
    const tooltipRef = useRef<UIGameResourceCardsTooltipContentHandle>(null)
    const {getPlayerValidator} = usePlayerValidators()
    const playerValidator = getPlayerValidator(myColor)
    const {sendBuyDevCard} = useUIGameSocketContext()
    const developmentCardValidator = useMechanicValidatorDevelopmentCard()
    const beginnerActionState = useGameStore((state) => state.gameBeginnerHint.beginnerActionState)

    const actionStatus = useMemo(() => {
        if(!developmentCardValidator) {
            return {canTakeAction: false}
        }

        const canBuyDevelopmentCardActionStatus = developmentCardValidator.canPlayerBuyDevelopmentCard(myColor)

        return canBuyDevelopmentCardActionStatus
    }, [developmentCardValidator, myColor])

    const triggerFlickerCardsAnimation = () => {
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuyDevCard)
        if(notEnoughResources) {
            tooltipRef.current?.triggerFlickerAnimation()
        }
    }
    const isNotBeginnerGameActionBuyDevCard = beginnerActionState != null && beginnerActionState?.type != GameAction.BuyDevelopmentCard
    const isHidden = beginnerActionState?.hiddenUIElements.includes(HiddenUIElement.BuyDevCardActionButton)
    const helperText: TranslationObject | undefined = errorHelperText || actionStatus.errorMessageIfCantTakeAction
    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isHidden || isNotBeginnerGameActionBuyDevCard

    const onClick = () => {
        if(disabled) return
        sendBuyDevCard()
    }

    return <UIGameActionButton
        id={ACTION_BUTTON_IDS.buyDevCard}
        className={clsx(className, {
            [styles.hidden]: isHidden,
        })}
        disabled={disabled}
        helperText={helperText}
        iconPath={CardDevCardBack}
        onClickActionIfDisabled={triggerFlickerCardsAnimation}
        tooltipCustomMenuComponent={
            !hideTooltip && (
                <UIGameResourceCardsTooltipContent
                    cardInventory={playerValidator.resourceCards.cards}
                    cardsToBuild={cardsToBuyDevCard}
                    ref={tooltipRef}/>
            )
        }
        onClick={onClick}
    />
}
